import { styled } from '@uhg-abyss/web/tools/styled';
import { Box } from '@uhg-abyss/web/ui/Box';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Link } from '@uhg-abyss/web/ui/Link';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';

export const ChoosePCPLocationAvatar = styled(Flex, {
  width: '42px',
  height: '42px',
  minWidth: '42px',
  minHeight: '42px',
  borderRadius: '50%',
  overflow: 'hidden',
  marginRight: '8px',
});

export const PCPHeaderContainer = styled('div', {
  borderBottom: 'solid',
  borderColor: '#E5E5E6',
  backgroundColor: '#FBFCFE',
  height: 'auto',
  marginBottom: '8px',
  '@media (max-width: 464px)': {
    marginBottom: '0',
  },
});

export const ContentWrapperFullWidth = styled('div', {
  marginLeft: 'calc((100vw - 1200px)/2)',
  padding: '24px 0',

  '@media (max-width: 1920px)': {
    marginLeft: 'calc((100vw - 1200px)/2)',
  },
  '@media (max-width: 1440px)': {
    marginLeft: 'calc((100vw - 1200px)/2)',
  },
  '@media (max-width: 1230px)': {
    marginLeft: '24px',
  },
  '@media (max-width: 464px)': {
    marginLeft: '12px',
  },
});

export const PCPCardWrapper = styled(Box, {
  '&.abyss-box-root': {
    backgroundColor: '#FBFCFE',
    padding: 0,
    '@media (max-width: 464px)': {
      display: 'flex',
      alignItems: 'center',
      '.mobile-nav-back-button': {
        height: '24px',
        marginTop: 0,
        marginLeft: 0,
      },
    },
  },
});

export const SelectedPCPCard = styled(Box, {
  borderRadius: '12px',
  boxShadow: '0px 2px 6px 0px rgba(25, 25, 26, 0.16)',
  '&.abyss-box-root': {
    backgroundColor: '#FFFFFF',
    width: '408px',
    '@media (max-width: 744px)': {
      width: '307px',
      backgroundColor: '$core.color.brand.100',
    },
    '@media (max-width: 464px)': { margin: 0 },
  },
});

export const ChooseLocationHeadingWrapper = styled('div', {
  marginBottom: '32px',
  position: 'sticky',
  '@media (max-width: 464px)': {
    '.abyss-text-root': {
      fontSize: '$md',
      lineHeight: '20px',
    },
  },
  '@media (max-width: 743px) and (orientation: landscape)': {
    position: 'static',
  },
});

export const ChooseLocationHeading = styled(Heading, {
  margin: '-8px 0 8px 0',
  '&.abyss-heading-root': {
    '@media (max-width: 464px)': {
      fontSize: '22.78px !important',
      lineHeight: '28px !important',
    },
  },
});
export const ChooseLocationRow = styled(Flex, {
  maxWidth: '408px',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const ChooseLocationLabel = styled(Heading, {
  dynamic: ({ cssProps: { isListView } = {} }) => ({
    marginBottom: isListView ? '10px' : 'unset',
  }),
  '&.abyss-heading-root': {
    lineHeight: '$md !important',
    '@media (max-width: 464px)': {
      fontSize: '$medium !important',
    },
  },
});

export const MobileViewMapButton = styled(Button, {
  '@media (min-width: 465px)': {
    display: 'none',
  },
  color: '$core.color.brand.60',
  '&.abyss-button-root': {
    height: '20px',
    padding: 0,
  },

  '&.abyss-button-content-container': {
    fontSize: '$xs',
    lineHeight: '16px',
  },
  '.abyss-insert-element-before': {
    paddingRight: '6px !important',
  },
});

export const ChooseLocationCardsContainer = styled(Flex, {
  maxHeight: '415px',
  overflow: 'auto',
  gap: '12px',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  '.location-cards-container': {
    width: '100%',
    border: '1px solid #E5E5E6',
    boxShadow: '0px 1px 4px rgba(25, 25, 26, 0.16)',
    borderRadius: '12px',
    '@media (max-width: 464px)': {
      backgroundColor: '$core.color.neutral.0',
    },
  },
});

export const NewPatientDisclaimer = styled('div', {
  margin: '12px 0',
  maxWidth: '408px',
  '.abyss-text-root': {
    display: 'block',
    lineHeight: '16px',
  },
});

export const ButtonRowBox = styled(Box, {
  '@media (max-width: 744px)': {
    bottom: '0',
    boxShadow: '0px -4px 12px rgba(25, 25, 26, 0.16)',
    marginBottom: '-$md',
    position: 'sticky',
    zIndex: 100,

    '&.abyss-box-root': {
      minHeight: '74px',
    },
    '@media (max-width: 743px) and (orientation: landscape)': {
      position: 'static',
    },
  },

  '@media (max-width: 464px)': {
    '&.abyss-box-root': {
      padding: '$md',
      marginTop: '12px',
    },
  },
});

export const ErrorBox = styled(Box, {
  marginBottom: '$md',
});

export const SaveAndCancelButton = styled(Button, {
  '&.abyss-button-root': {
    height: '42px',
    fontWeight: '600',
    borderWidth: '2px',
    padding: '$sm $md $sm $lg',
    '.abyss-insert-element-after': {
      paddingLeft: 0,
    },
    '&.cancel-button': {
      paddingRight: '$lg',
    },
  },
});

export const LocationsWrapColumn = styled('div', {
  height: '583px',
  position: 'absolute',
  display: 'inline-block',
  overflow: 'visible',
  backgroundColor: '$core.color.neutral.0',
  zIndex: 10,
  boxShadow: '10px 0px 5px -5px rgba(0, 0, 0, 0.2)',
  paddingRight: '$lg',
  '@media (min-width: 465px)': { maxWidth: '432px' },
  '@media (max-width: 464px)': {
    width: '100%',
    height: '532px',
    boxShadow: 'unset',
    padding: '0',
  },
});

export const MapViewWrap = styled('div', {
  dynamic: ({
    cssProps: { closeSidePanel, mobileRouteView, enableMapEnhancements } = {},
  }) => ({
    '.abyss-card-root': {
      width: closeSidePanel ? '100%' : 'calc(100% - 400px)',
      marginLeft: closeSidePanel
        ? '0'
        : enableMapEnhancements
        ? '432px'
        : '400px',
      '@media (max-width: 464px)': {
        height: mobileRouteView ? '100vh' : '532px',
      },
    },
  }),
  '.abyss-card-root': {
    height: '583px',
    border: 'none',
    boxShadow: 'unset',
    '.map-container': {
      height: '583px',
      width: '100%',
    },
  },
  '@media (max-width: 464px)': {
    '.abyss-card-root ': {
      width: '100% !important',
      marginLeft: '0 !important',
      '.map-container': {
        height: '100vh',
      },
    },
  },
  '.mapboxgl-ctrl-bottom-left': {
    display: 'none',
  },
  '.mapboxgl-ctrl-bottom-right': {
    display: 'none',
  },
});

export const SidePaneCloseButton = styled(Flex, {
  right: '-26px',
  top: '24px',
  position: 'absolute',
  zIndex: 1,
  height: '42px',
  width: '26px',
  backgroundColor: 'white',
  borderRadius: '0 4px 4px 0',
  border: '1px solid #E5E5E5',
  borderLeft: 'none',
  boxShadow: '5px 5px 5px rgba(0, 0, 0, 0.2)',
  cursor: 'pointer',
  '@media (max-width: 464px)': {
    display: 'none',
  },
});

export const MobileMapViewWrap = styled('div', {
  dynamic: ({ cssProps: { mobileRouteView } = {} }) => ({
    position: 'relative',
    '&.show-mobile-map-view': {
      position: 'relative',
      paddingRight: 0,
      '.locations-wrap-column': {
        width: '100%',
        background: 'transparent',
        bottom: 0,
        height: mobileRouteView ? '0' : '215px',
        padding: 0,
        '.choose-location-container': {
          maxWidth: 'unset',
          flexWrap: 'unset',
        },
      },

      '.abyss-card-root .map-container': {
        borderRadius: '0px',
      },
    },
  }),
});

export const StyledUpdateErrorModal = styled(ModalDialog, {
  '&.abyss-modal-base-body': {
    maxHeight: '100%',
  },
});

export const StyledTopModalSection = styled('div', {
  padding: '16px 16px 12px',
});

export const StyledMiddleModalSection = styled('div', {
  padding: '0 16px 16px',

  '@media (max-width: 464px)': {
    padding: '0 16px 12px',
  },
});

export const StyledLowerModalSection = styled('div', {
  padding: '16px 24px',

  '@media (max-width: 464px)': {
    padding: '12px 16px 16px',
  },
});

export const StyledLowerFlex = styled(Flex, {
  '&.abyss-flex-root': {
    margin: '0 -4px',

    '@media (max-width: 464px)': {
      margin: '-4px 0',
    },
  },
});

export const StyledUpdateErrorIcon = styled(IconBrand, {
  margin: '71px 0 5px 0',

  '@media (max-width: 464px)': {
    margin: '48px 0 5px 0',
  },
});
export const StyledTopModalSectionUSP = styled('div', {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  padding: '0 16px',
  marginTop: '16px',
  '@media (max-width: 464px)': {
    marginTop: 0,
    padding: 0,
  },
});

export const StyledLowerModalSectionUSP = styled('div', {
  display: 'flex',
  outline: '1px solid #E5E5E6',
  flexDirection: 'column',
  gap: '16px',
  padding: '16px 24px',
  alignItems: 'baseline',
});

export const StyledLowerContentFlex = styled(Flex, {
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '16px',
  '&.abyss-flex-root': {
    margin: '0',
    '@media (max-width: 464px)': {
      margin: ' 0',
    },
  },
});

export const ErrorHeaderContainer = styled('div', {
  width: '100%',
  fontWeight: '700',
  fontSize: '22.78px',
  lineHeight: '32px',
  textAlign: 'center',
  '@media (max-width: 464px)': {
    fontSize: '18px',
    lineHeight: '24px',
    textAlign: 'left',
  },
});

export const ChatAndCallContainer = {
  margin: '2px 2px 2px 0',
  fontWeight: '700',
  fontSize: '14.22px',
  lineHeight: '20px',
};

export const StyledLocationItems = styled(Layout.Stack, {
  gap: '4px',
  '@media (max-width: 464px)': {
    padding: '16px',
    gap: '8px',
  },
});

export const ErrorContentContainer = styled('div', {
  width: '100%',
  fontWeight: '500',
  fontSize: '14px',
  lineHeight: '18px',
  textAlign: 'center',
  '@media (max-width: 464px)': {
    textAlign: 'left',
    marginTop: '3px',
  },
});

export const ReturnToSearchResultsButton = styled(Button, {
  '&.abyss-button-root': {
    padding: '10px 24px 10px 24px',
    width: '284px',
    lineHeight: '20px',
    margin: '10px 0',
    height: 'auto',
    '@media (max-width: 464px)': {
      width: '288px',
    },
  },
});

export const TopTitleStyle = styled('div', {
  height: '62px',
  padding: '16px',
  borderRadius: '8px 8px 0 0',
  '@media (max-width: 464px)': {
    height: '52px',
  },
});

export const StyledRestartSearchButton = styled(Button, {
  '&.abyss-button-root': {
    margin: '0',
    width: '280px',

    '@media (max-width: 464px)': {
      margin: '18px 0 10px',
      width: '288px',
    },
  },
});

export const StyledContactUsLink = styled(Link, {
  '&.abyss-link-root': {
    display: 'inline',
  },
});

export const StyledContactUsButton = styled(Button, {
  '&.abyss-button-root': {
    margin: '0 4px',
    width: '284px',

    '@media (max-width: 464px)': {
      margin: '4px 0',
      width: '288px',
    },
  },
});

export const StyledProviderName = styled('div', {
  dynamic: ({ cssProps: { removeTruncatedDataCard } = {} }) => ({
    maxWidth: removeTruncatedDataCard ? 'unset' : '335px',
    whiteSpace: removeTruncatedDataCard ? 'normal' : 'nowrap',
    overflow: removeTruncatedDataCard ? 'visible' : 'hidden',
    textOverflow: removeTruncatedDataCard ? 'unset' : 'ellipsis',
    '@media (max-width: 744px)': {
      maxWidth: removeTruncatedDataCard ? 'unset' : '235px',
    },
  }),
});

export const LocationWrapperFullWidth = styled('div', {
  marginLeft: 'calc((100vw - 1200px)/2)',
  padding: '24px 0 0 0',

  '@media (max-width: 1920px)': {
    marginLeft: 'calc((100vw - 1200px)/2)',
  },
  '@media (max-width: 1440px)': {
    marginLeft: 'calc((100vw - 1200px)/2)',
  },
  '@media (max-width: 1230px)': {
    marginLeft: '24px',
  },
  '@media (max-width: 464px)': {
    marginLeft: '12px',
  },
});

export const DemoUpdatePCPErrorModalContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  fontFamily: '$primary',
  backgroundColor: '$bgHeaderColor',
  paddingLeft: '16px',
  paddingTop: '1em',
  paddingBottom: '1.1em',
  marginRight: '24px',
  '@media (max-width: 744px)': {
    marginRight: '16px',
  },
});

export const CollapseIconContainer = styled('div', {
  position: 'relative',
});

export const CollapseIcon = styled(IconSymbol, {
  position: 'absolute',
  right: '24px',
  top: '-42px',
});

export const StyledPCPErrorViewStack = styled(Layout.Stack, {
  '&.abyss-layout-stack': {
    marginTop: '76px',
    '@media (max-width: 744px)': {
      marginTop: '44px',
    },
  },
  '> div': {
    maxWidth: '400px',
    textAlign: 'center',
  },
});

export const StyledPCPErrorViewIcon = styled(IconBrand, {
  backgroundColor: '$core.color.aqua.15',
  '&.abyss-icon-brand': {
    paddingTop: '12px',
  },
});

export const ListViewBtnContainer = styled('div', {
  padding: '10px 0',
});
